import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from "../Config";
import "react-toastify/dist/ReactToastify.css";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import {
  Users,
  Flag,
  UserCheck,
  BookOpen,
  Book,
  Compass,
  Activity,
  DollarSign,
  Phone,
  CreditCard,
} from "react-feather";

const Dashboard = () => {
  const [users, setUsers] = useState(0);
  const [contact, setContact] = useState(0);
  const [citizenship, setCitizenship] = useState(0);
  const [ethnicity, setEthnicity] = useState(0);
  const [religious, setReligious] = useState(0);
  const [education, setEducation] = useState(0);
  const [hobbies, setHobbies] = useState(0);
  const [income, setIncome] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axiosInstance.get("/dashboard");

        const body = response.data;
        setUsers(body?.user || 0);
        setContact(body?.contact || 0);
        setCitizenship(body?.citizenship || 0);
        setEthnicity(body?.ethnicity || 0);
        setReligious(body?.religious || 0);
        setEducation(body?.education || 0);
        setHobbies(body?.hobbies || 0);
        setIncome(body?.income || 0);
      } catch (error) {
        // console.error("Error fetching dashboard data:", error);
      }
    };

    fetchDashboardData();
  }, [navigate]);

  const [monthlyStats, setMonthlyStats] = useState([]);

  const monthLabels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  useEffect(() => {
    const fetchMonthlyStats = async () => {
      try {
        const res = await axiosInstance.get("/getMonthlyUserStats");
        const stats = res.data?.body || [];

        const formatted = stats.map((item) => ({
          name: monthLabels[item?.month - 1],
          users: item?.user || 0,
          matches: item?.match || 0,
        }));

        setMonthlyStats(formatted);
      } catch (err) {
        // console.log("monthly stats error:", err);
        setMonthlyStats([]);
      }
    };

    fetchMonthlyStats();
  }, []);


  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="title-box mb-3 pb-1">
              <h4 className="mb-0 page-title">Dashboard</h4>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard" className="new">
                      <i className="ri-home-4-fill me-1 new" /> Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/dashboard" className="new">
                      Dashboard
                    </Link>
                  </li>

                </ol>
              </nav>
            </div>

            <div className="row mb-4">
              <div className="col-lg-12">
                <div className="card key-matrix mb-0">
                  <div className="card-body pb-0">
                    <div className="card-head mb-3">
                      <div>
                        <div className="card-title mb-0">Metrics</div>
                      </div>
                    </div>
                    <div className="row gx-3">
                      <div className="col-lg-3 col-sm-4">
                        <div className="card bg-soft-theme">
                          <div
                            className="card-body"
                            style={{ paddingBottom: "13px", cursor: "pointer" }}
                            onClick={() => navigate("/userlist")}
                          >
                            <div className="icon-font icon-bg-theme">
                              <Users size={20} color="#fff" />
                            </div>
                            <div>
                              <h5 className="mb-1 mt-2 fw-semibold">{users}</h5>
                              <p className="text-muted mb-1 fw-medium font-size-15 one-ellips">
                                Total Users
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-lg-3 col-sm-4">
                        <div className="card bg-soft-theme">
                          <div
                            className="card-body"
                            style={{ paddingBottom: "13px", cursor: "pointer" }}
                            onClick={() => navigate("/citizenshipList")}
                          >
                            <div className="icon-font icon-bg-theme">
                              <Flag size={20} color="#fff" />
                            </div>
                            <div>
                              <h5 className="mb-1 mt-2 fw-semibold">{citizenship}</h5>
                              <p className="text-muted mb-1 fw-medium font-size-15 one-ellips">
                                Citizenship
                              </p>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <div className="col-lg-3 col-sm-4">
                        <div className="card bg-soft-theme">
                          <div
                            className="card-body"
                            style={{ paddingBottom: "13px", cursor: "pointer" }}
                            onClick={() => navigate("/ethnicityList")}
                          >
                            <div className="icon-font icon-bg-theme">
                              <UserCheck size={20} color="#fff" />
                            </div>
                            <div>
                              <h5 className="mb-1 mt-2 fw-semibold">{ethnicity}</h5>
                              <p className="text-muted mb-1 fw-medium font-size-15 one-ellips">
                                Ethnicity
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-4">
                        <div className="card bg-soft-theme">
                          <div
                            className="card-body"
                            style={{ paddingBottom: "13px", cursor: "pointer" }}
                            onClick={() => navigate("/religiousList")}
                          >
                            <div className="icon-font icon-bg-theme">
                              <BookOpen size={20} color="#fff" />
                            </div>
                            <div>
                              <h5 className="mb-1 mt-2 fw-semibold">{religious}</h5>
                              <p className="text-muted mb-1 fw-medium font-size-15 one-ellips">
                                Religious Beliefs
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-4">
                        <div className="card bg-soft-theme">
                          <div
                            className="card-body"
                            style={{ paddingBottom: "13px", cursor: "pointer" }}
                            onClick={() => navigate("/educationList")}
                          >
                            <div className="icon-font icon-bg-theme">
                              <Book size={20} color="#fff" />
                            </div>
                            <div>
                              <h5 className="mb-1 mt-2 fw-semibold">{education}</h5>
                              <p className="text-muted mb-1 fw-medium font-size-15 one-ellips">
                                Education
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-4">
                        <div className="card bg-soft-theme">
                          <div
                            className="card-body"
                            style={{ paddingBottom: "13px", cursor: "pointer" }}
                            onClick={() => navigate("/hobbieList")}
                          >
                            <div className="icon-font icon-bg-theme">
                              <Activity size={20} color="#fff" />
                            </div>
                            <div>
                              <h5 className="mb-1 mt-2 fw-semibold">{hobbies}</h5>
                              <p className="text-muted mb-1 fw-medium font-size-15 one-ellips">
                                Hobbies
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-4">
                        <div className="card bg-soft-theme">
                          <div
                            className="card-body"
                            style={{ paddingBottom: "13px", cursor: "pointer" }}
                            onClick={() => navigate("/incomeList")}
                          >
                            <div className="icon-font icon-bg-theme">
                              <DollarSign size={20} color="#fff" />
                            </div>
                            <div>
                              <h5 className="mb-1 mt-2 fw-semibold">{income}</h5>
                              <p className="text-muted mb-1 fw-medium font-size-15 one-ellips">
                                Income
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-4">
                        <div className="card bg-soft-theme">
                          <div
                            className="card-body"
                            style={{ paddingBottom: "13px", cursor: "pointer" }}
                            onClick={() => navigate("/contactlist")}
                          >
                            <div className="icon-font icon-bg-theme">
                              <Phone size={20} color="#fff" />
                            </div>
                            <div>
                              <h5 className="mb-1 mt-2 fw-semibold">{contact}</h5>
                              <p className="text-muted mb-1 fw-medium font-size-15 one-ellips">
                                Contact Us
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <h5 className="mb-3">Users</h5>

                    <div style={{ width: "100%", height: 320 }}>
                      <ResponsiveContainer>
                        <BarChart data={monthlyStats}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis allowDecimals={false} />
                          <Tooltip />
                          <Legend />
                          <Bar dataKey="users" name="Users" fill="#963F02" />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <h5 className="mb-3">Matches</h5>

                    <div style={{ width: "100%", height: 320 }}>
                      <ResponsiveContainer>
                        <BarChart data={monthlyStats}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis allowDecimals={false} />
                          <Tooltip />
                          <Legend />
                          <Bar dataKey="matches" name="Matches" fill="#963F02" />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div className="container-fluid">
              <div className="row">
                <div className="col-6"></div>
                <div className="col-6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;